import lodashCloneDeep from 'lodash/cloneDeep';

/**
 * @description 这是structuredClone的hack实现，注意options仅在structuredClone原生支持时生效
 * @example
 * const cloned = cloneDeep(bigObject);
 */
export const cloneDeep = <T>(
  value: T,
  options?: StructuredSerializeOptions,
) => {
  if (typeof structuredClone === 'function') {
    return structuredClone(value, options);
  }
  return lodashCloneDeep(value);
};
